<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'+'监控'"
    :close-on-click-modal="false"
    :before-close="handleClose"
    :visible.sync="visible"
    width="720px"
    height="456px"
    class="info-dialog"
  >
    <el-form
      ref="dataForm"
      label-position="right"
      label-width="120px"
      :model="dataForm"
      :rules="rules"
    >
      <el-form-item prop="name" label="场地名称：">
        <el-select v-model="dataForm.roomId" placeholder="请选择场地名称" @change="filedSelectHandle">
          <el-option
            v-for="item in getBidList"
            :key="item.id"
            :label="item.filedName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="cameraName" label="监控名称：">
        <el-input
          v-model.trim="dataForm.cameraName"
          placeholder="请输入监控名称"
          maxlength="30"
          clearable
        />
      </el-form-item>
      <el-form-item prop="cameraCode" label="监控编码：">
        <el-input
          v-model.trim="dataForm.cameraCode"
          placeholder="请输入监控编码"
          maxlength="30"
          clearable
        />
      </el-form-item>
      <el-form-item prop="cameraUrl" label="监控地址：">
        <el-input
          v-model.trim="dataForm.cameraUrl"
          placeholder="请输入监控地址"
          clearable
          maxlength="255"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-preventReClick type="primary" @click="dataFormSubmit()">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      getBidList: [],
      dataForm: {
        id: '',
        tradeOrgId: '',
        filedName: '',
        roomId: '',
        cameraName: '',
        cameraCode: '',
        cameraUrl: ''
      },
      rules: {
        roomId: [
          { required: true, message: '请选择场地名称', trigger: 'blur' }
        ],
        cameraName: [
          { required: true, message: '请填写监控名称', trigger: 'blur' }
        ],
        cameraCode: [
          { required: true, message: '请填写监控编码', trigger: 'blur' }
        ],
        cameraUrl: [
          { required: true, message: '请填写监控视频地址', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {},
  methods: {
    // 下拉选择列表处理
    filedSelectHandle(val) {
      const index = this.getBidList.findIndex(mitem => mitem.id === val)
      if (index > -1) {
        this.dataForm.filedName = this.getBidList[index].filedName
      } else {
        this.dataForm.filedName = ''
      }
    },

    handleClose() {
      this.visible = false
    },
    getBid(tradeOrgId) {
      this.$http.get(`/configs/sysevalroom/getEvalRoomOptions?tradeOrgId=${tradeOrgId}`).then(res => {
        if (res.data.code === '1') {
          this.getBidList = res.data.data || []
        }
      })
    },
    init(id, tradeOrgId) {
      this.visible = true
      this.dataForm.id = id || ''
      this.dataForm.tradeOrgId = tradeOrgId
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        this.getBid(tradeOrgId)
        if (this.dataForm.id) {
          this.$http.get(`/configs/sysevalroomcameras/get?id=${id}`).then(res => {
            if (res.data.code === '1') {
              this.dataForm = res.data.data ? res.data.data : {}
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http.post(`/configs/sysevalroomcameras/save`,this.dataForm).then(res => {
            if (res.data.code === '1') {
              this.$message.success(res.data.msg)
              this.visible = false
              this.$emit('refreshDataList')
            } else {
              this.$message.error(res.data.msg)
              this.visible = false
            }
          })
        }
      })
    }
  }
}
</script>
